import React from 'react'
import { Region } from '@enonic/react-components';

import Section from '../../../react4xp/components/Section'
import SolutionsPageHero from '../../../react4xp/components/SolutionsPageHero'
import AreasOfExpertise from '../../../react4xp/components/AreasOfExpertise'
import Solutions from '../../../react4xp/components/Solutions'

function SolutionLayout(props) {
	const {
		tag,
		title,
		intro,
		image,
		video,
		twoColumnsContent,
		areasOfExpertise,
		regions,
		moreSolutions,
		componentPath
	} = props

	return (
		<>
			<Section bgColor='bg-beige-primary-light' >
				<SolutionsPageHero
					tag={tag}
					title={title}
					text={intro}
					img={image}
					video={video}
					twoColumnsContent={twoColumnsContent}
				/>
			</Section>
			<Section bgColor="bg-primary" textColor="text-light">
				<AreasOfExpertise 
					tag={areasOfExpertise.tag}
					expertises={areasOfExpertise.expertises}
				/>
			</Section>
			<Region name={regions.main.name} regionData={regions.main} />
			<Solutions
				componentPath={componentPath}
				title={moreSolutions.title}
				solutions={moreSolutions.solutions}
			/>
		</>
	)
}

export default (props) => <SolutionLayout {...props} />
